import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GroupsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"groups"}/>
}
